import { css } from '@emotion/react';
import { dottedSeparatorStyle } from '../../patron-details.style';

const contactNumberStyle = css`
  display: inline-flex;
  align-items: center;
  overflow: hidden;

  .phone-number {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

interface GetContactNumberStyleConfig {
  shouldShowVerticalSeparator: boolean;
}

export function getContactNumberStyle({ shouldShowVerticalSeparator }: GetContactNumberStyleConfig) {
  if (shouldShowVerticalSeparator) {
    return [contactNumberStyle, dottedSeparatorStyle];
  }

  return contactNumberStyle;
}
